import React from 'react'
import DataTable from '../../DataTable/DataTable'
import clsx from "clsx"

export default class FeeBuilderTasks extends React.Component {
  constructor(props) {
    super(props)

  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "tasks",
      'tab-pane': true
    });

    return(
      <div className={tabClasses} id="notes">
        <DataTable endpoint={this.props.tax_task_logs_data_table_path ? this.props.tax_task_logs_data_table_path : this.props.fee_task_logs_data_table_path}  date_format={this.props.date_format} time_format={this.props.time_format} read_only={this.props.read_only} inModal={true}/>
      </div>
    )

  }


}
